import { API_BASE_URL } from "../utils/apiConfig";

export const USE_MOCK_API = process.env.REACT_APP_USE_MOCK_API === "true";

export const API_ENDPOINTS = {
  unregisterGroupTravel: `${API_BASE_URL}/GroupTravel/Cancel`,

  getTravelDetails: (referenceId: string, editId: string) =>
    `${API_BASE_URL}/GroupTravel/GetDetails?referenceId=${encodeURIComponent(referenceId)}&editId=${encodeURIComponent(editId)}`,
};
